// Lesson sequencing is reached from the sidebar (`useSequencingReachable`
// decides whether it is listed), so the welcome carries no actions.
const TeacherWelcome = () => (
  <section className="et-welcome">
    <div>
      <h1>
        Hey <em>Educator,</em>
      </h1>
      <p>Let's shape the future of teaching and learning, Evertutor Live.</p>
    </div>
    <img
      src="/assets/math-heart.svg"
      alt=""
      aria-hidden="true"
      className="et-welcome-art-muted"
    />
  </section>
);

export default TeacherWelcome;
